export default __webpack_public_path__ + "static/Learn Chinese Fast-f7c1ac017f7ce3779187d84b4c7767d1.jpg";